import { getInitialNodes } from '@/flow/config/fixedNodes';
import type { FlowLayoutPreset } from '@/flow/config/layoutPreset';
import type { AppEdge, AppNode } from '@/flow/types';

export const createInitialMazeFlow = (preset: FlowLayoutPreset): {
  nodes: AppNode[];
  edges: AppEdge[];
} => ({
  nodes: getInitialNodes(preset),
  edges: [],
});